import React, { useState } from "react";
import "./Tweet.css";
import { Button, Avatar } from "@material-ui/core";
import db from "./firebase";
function Tweet() {
const [tweetmessage,settweetmessage]=useState([]);
const [tweetimage,settweetimage]=useState([]);
const abc = (e) => {
  e.preventDefault();


  db.collection("post").add({
    displayName: "Rishabh agarwal",
    username: "risaashi",
    verified: true,
    text: tweetmessage,
    image: tweetimage,
    avatar:
      "https://i.guim.co.uk/img/media/f1cf534836a8499ba2c0deff509241428abea9ea/28_0_803_482/master/803.jpg?width=1200&height=630&quality=85&auto=format&fit=crop&overlay-align=bottom%2Cleft&overlay-width=100p&overlay-base64=L2ltZy9zdGF0aWMvb3ZlcmxheXMvdGctZGVmYXVsdC5wbmc&enable=upscale&s=eee457fe1ef45a0d4bef897ca0451d4d",
  });
  settweetmessage("");
    settweetimage("");

}
  return (
    <div className="tweety">
      <form >
        <div className="tweetyInput">
        <Avatar src="https://filmdaily.co/wp-content/uploads/2018/03/ju-on-the-grudge-horror-film.jpg" />
        <input 
        onChange={(x)=> settweetmessage(x.target.value)}
        type="text" placeholder="What's happening ?" />
      </div>
      <input 
      onChange={(y)=>settweetimage(y.target.value)}
        type="text"
        className="aaaa"
        placeholder="IMAGE URL..." />
      <Button onClick={abc} type="submit"className="butt">Tweet</Button>
      </form>
    </div>
  );
}
export default Tweet;
